/**
 * 员工手机端导航
 * ---------------------------------------------------------------------------
 * 产品文档 §8.10 明确规定主导航只有四个入口，§5.6 又补了一句
 * "非必要功能不进入主导航"。所以这个数组的长度是产品约束，不是排版偏好——
 * 想加第五个 tab 之前，先回去确认这条口径是否已经改了。
 *
 * 四页共用同一个权限码 staff.self.read：服务端的 /employee/* 全部要求它，
 * 没有这个权限的账号进任何一页都只会拿到 403，所以守卫层直接拦在门口，
 * 不让用户点进去再看到四次报错。
 */
import type { IconName } from '@/components/icons';

export type MobileNavItem = {
  path: string;
  /** 底部导航文案，最多三个字，多了在小屏上会换行 */
  label: string;
  icon: IconName;
  /** 顶栏标题 */
  title: string;
  permission: string;
};

export const MOBILE_NAV_ITEMS: MobileNavItem[] = [
  {
    path: '/m/today',
    label: '今天',
    icon: 'home',
    title: '今天',
    permission: 'staff.self.read',
  },
  {
    path: '/m/customers',
    label: '顾客',
    icon: 'users',
    title: '我的顾客',
    permission: 'staff.self.read',
  },
  {
    path: '/m/earnings',
    label: '提成',
    icon: 'coin',
    title: '我的提成',
    permission: 'staff.self.read',
  },
  {
    path: '/m/profile',
    label: '我的',
    icon: 'user',
    title: '我的',
    permission: 'staff.self.read',
  },
];

/** 按当前路由取页面信息，供顶栏标题和路由守卫使用 */
export function findMobileNavItem(pathname: string): MobileNavItem | null {
  return (
    MOBILE_NAV_ITEMS.find((item) => pathname === item.path) ??
    MOBILE_NAV_ITEMS.find((item) => pathname.startsWith(`${item.path}/`)) ??
    null
  );
}
